// Announcement cookie handling
(function () {
    var panel = document.querySelector('.announcement');
    var closeButton = document.getElementById('announcement__close');
    if (!panel || !closeButton) return;

    var announcementId = panel.getAttribute('data-announcement-id');
    var cookieName = panel.getAttribute('data-cookie-name') || 'announcements';
    var isHttps = window.location.protocol === 'https:';

    function parseCookie(name) {
        try { return JSON.parse(Cookies.get(name) || '{}'); } catch (e) { return {}; }
    }

    // Drop stale dated cookies from older publishes
    Object.keys(Cookies.get() || {})
        .filter(function (key) { return key.indexOf('announcements-') === 0 && key !== cookieName; })
        .forEach(function (staleKey) {
            Cookies.remove(staleKey, { path: '/', sameSite: 'Lax', secure: isHttps });
        });

    var announcements = parseCookie(cookieName);
    var isAlreadyClosed = announcements[announcementId] && announcements[announcementId].closed;

    if (isAlreadyClosed) panel.classList.add('hidden');
    else document.body.classList.add('body--announcement-visible');

    closeButton.addEventListener('click', function () {
        panel.classList.add('hidden');
        document.body.classList.remove('body--announcement-visible');

        var duration = parseInt(panel.getAttribute('data-announcement-duration'), 10) || 1;
        var updated = parseCookie(cookieName);
        updated[announcementId] = { closed: true };

        Cookies.set(cookieName, JSON.stringify(updated), {
            expires: duration,
            path: '/',
            sameSite: 'Lax',
            secure: isHttps
        });
    });
})();
